import React, {useEffect, useState} from "react";
import Utstillinger from "../components/Utstillinger";
import {getUtstillingsresultater, getUtenlandskeUtstillingResultater, getEksterioerGodkjennelseResultater} from "../api";
import {withRouter} from "react-router-dom";

const UtstillingerContainer = (props) => {
    const { id } = props.match.params;
    const hund = props.hund;

    const {utstillingsresultater} = useFetchUtstillingsresultater(hund.hundId, id);

    const {utenlandskeResultater} = useFetchUtenlandskeResultater(hund.hundId, id);

    const {eksterioerGodkjennelseResultater} = useFetchEksterioerGodkjennelseResultater(hund.hundId, id);


    return (
        <Utstillinger hund={hund} utstillingsresultater={utstillingsresultater}
                      utenlandskeResultater={utenlandskeResultater}
                      eksterioerGodkjennelseResultater={eksterioerGodkjennelseResultater} />
    );
};



const useFetchUtstillingsresultater = (hundId, id) => {
    const [utstillingsresultater, setUtstillingsresultater] = useState([]);
    const [isUtstillingsresultaterLoading, setIsUtstillingsresultaterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsUtstillingsresultaterLoading(true);
            }
            getUtstillingsresultater(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setUtstillingsresultater(data);
                        setIsUtstillingsresultaterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsUtstillingsresultaterLoading(false);
                        setUtstillingsresultater(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { utstillingsresultater, isUtstillingsresultaterLoading };
};

const useFetchUtenlandskeResultater = (hundId, id) => {
    const [utenlandskeResultater, setUtenlandskeResultater] = useState([]);
    const [isUtenlandskeResultaterLoading, setIsUtenlandskeResultaterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsUtenlandskeResultaterLoading(true);
            }
            getUtenlandskeUtstillingResultater(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let resultater = [];
                        for (var i = 0; i < data.length; i++) {
                            resultater.push(data[i]);
                        }
                        setUtenlandskeResultater(resultater);
                        setIsUtenlandskeResultaterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsUtenlandskeResultaterLoading(false);
                        setUtenlandskeResultater(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { utenlandskeResultater, isUtenlandskeResultaterLoading };
};


const useFetchEksterioerGodkjennelseResultater = (hundId, id) => {
    const [eksterioerGodkjennelseResultater, setEksterioerGodkjennelseResultater] = useState([]);
    const [isEksterioerGodkjennelseResultaterLoading, setEksterioerGodkjennelseResultaterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setEksterioerGodkjennelseResultaterLoading(true);
            }
            getEksterioerGodkjennelseResultater(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let resultater = [];
                        for (var i = 0; i < data.length; i++) {
                            resultater.push(data[i]);
                        }
                        setEksterioerGodkjennelseResultater(resultater);
                        setEksterioerGodkjennelseResultaterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        console.log(err);
                        setEksterioerGodkjennelseResultaterLoading(false);
                        setEksterioerGodkjennelseResultater(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return {eksterioerGodkjennelseResultater, isEksterioerGodkjennelseResultaterLoading };
};



export default withRouter(UtstillingerContainer);
